// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3saK7","item":"PaymentsMobile_item__3qUvj","label":"PaymentsMobile_label__3f7x-","amount":"PaymentsMobile_amount__sfu7U"};